import Avatar2 from "../../assets/images/lg/avatar2.jpg";
import Avatar9 from "../../assets/images/lg/avatar9.jpg";
import moment from "moment/moment";

function UpcommingInterviews({ data }) {

    return (
        <div className="card">
            <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                <h6 className="mb-0 fw-bold ">In Progress Task</h6>
            </div>
            <div className="card-body">
                <div className="flex-grow-1">
                    {data?.task.map((task, index) => (
                        <div key={index} className="py-2 d-flex align-items-center border-bottom flex-wrap">
                            <div className="d-flex align-items-center flex-fill">
                                <img className="avatar lg rounded-circle img-thumbnail" src={task?.assignPerson?.employeeProfileImage ? task?.assignPerson?.employeeProfileImage : task?.assignPerson?.gender === "Men" ? Avatar9 : Avatar2} crossOrigin="anonymous" alt="profile" />
                                <div className="d-flex flex-column ps-3">
                                    <h6 className="fw-bold mb-0 small-14">{task?.assignPerson?.employeeName}</h6>
                                    <span className="text-muted">{task?.projectId?.projectName}</span>
                                </div>
                            </div>
                            <div className="time-block text-truncate">
                                <i className="icofont-clock-time"></i>
                                {moment.utc(task?.taskStartDate).format("DD-MM-YYYY HH:mm")}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}


export default UpcommingInterviews;